export default "__VITE_ASSET__yWjZHPvq__"